import React from 'react';
import arrowGreen from '../../assets/images/arrow-green.svg';
import arrowWhite from '../../assets/images/arrow-white.svg';

const CaseStudies = () => {
  return (  
    <div className="row">
      <div className="col-md-6 case-studies-outer bg-light-green p-5">
        <div className="case-studies-inner">
          <span className="text-primary fs-36">Download <br></br>Case-studies</span><br></br>
          <span className="fs-14 text-gray text">SmartDrive uses video-based safety program to<br></br> make transport safer and smarter. Take a closer look <br></br>at the transformations our presence had brought<br></br> about to fleets and drivers.</span>
        </div>
          <span><img src={arrowGreen} alt="Green Arrow" /></span>
      </div>
      <div className="col-md-6 case-studies-outer bg-secondary p-5">
        <div className="case-studies-inner">
          <span className="text-white fs-36">Join Us.</span><br></br>
          <span className="text-white fs-14">We are pioneer engineers in video-based<br></br> safety programs. Join us to build safe<br></br> and intelligent transport safety programs<br></br> that guard and guide the way. </span>
        </div><span><img src={arrowWhite} alt="White Arrow" /></span>
      </div>
    </div>
  );
}
 
export default CaseStudies;